import { render, staticRenderFns } from "./basicDetailEdit.vue?vue&type=template&id=53011b4d&scoped=true&"
import script from "./basicDetailEdit.vue?vue&type=script&lang=js&"
export * from "./basicDetailEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53011b4d",
  null
  
)

export default component.exports